export default "__VITE_ASSET__DBZDQeDt__"